module.exports = __webpack_public_path__ + "static/img/3_phase_function_Paper_PointsHejduk_Prediction.ba3523b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3_phase_function_Paper_PointsHejduk_Prediction.png
// module id = rfX8
// module chunks = 0